import React from 'react';

interface DeathCrossIconProps {
  className?: string;
  title?: string;
}

const DeathCrossIcon: React.FC<DeathCrossIconProps> = ({ className = "w-4 h-4", title }) => {
  return (
    <>
      {/* Light mode - Light death cross icon */}
      <img
        src="/images/death-cross-light-icon.png"
        alt="Death Cross"
        className={`${className} dark:hidden`}
        title={title}
      />
      {/* Dark mode - Original death cross icon */}
      <img
        src="/images/death-cross-icon.png"
        alt="Death Cross"
        className={`${className} hidden dark:block`}
        title={title}
      />
    </>
  );
};

export default DeathCrossIcon;

